module.exports = __webpack_public_path__ + "img/1.d11b6c04.svg";